<template>
  <mdb-container v-if="loggedIn" class="gp-has-header">
    <mdb-card class="mb-4">
      <mdb-card-header class="primary-color text-white">
        <h4>Link to Meetup</h4>
      </mdb-card-header>
      <mdb-card-body class="text-left" v-if="alreadyLinked">
        {{linkedMessage}}
      </mdb-card-body>
      <mdb-card-body class="text-left" v-if="!alreadyLinked && linkChecked">
        <p>In order to see if you're eligible for an extended free trial, you need to know your Meetup user identifier. This is a
          usually a value similar to "user 123456789", but you might have customized the value as well.  You can find your unique
          user ID on your <a href="https://meetup.com/account/" target="_blank">Meetup account page.</a>
          <b>Copy the full User ID value, including the word "user" if it is there.</b>
        </p>

        <img src="https://static.ezumee.com/meetup_user_id.png"/>

        <mdb-input label="Your Meetup User ID" id="id-input" type="text" v-model="meetupUserId" placeholder="Enter your Meetup User ID here"/>
        <mdb-btn :disabled="!meetupUserId" icon="check" @click="checkId">See if I'm Eligible</mdb-btn>


      </mdb-card-body>
    </mdb-card>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import Avatar from "../common/Avatar";
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbRow
} from 'mdbvue';

export default {
  name: "user-blocks",
  display: "User Blocks",
  order: 1,
  components: {
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbBtn,
    mdbIcon,
    mdbInput,
    mdbRow,
    mdbCol,
    mdbChip,
    Avatar
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    userDetails() {
      return this.$store.state.userDetails
    },
  },
  data() {
    return {
      meetupUserId: "",
      alreadyLinked: false,
      linkChecked: false,
      linkedMessage: "You have already linked your account to your Meetup User ID."
    }
  },
  mounted() {
    document.title = "Meetup Link"
    let el = document.getElementById("id-input");
    if (el) el.focus();
    api.get("/user/meetupLink").then(
      (results) => {
        this.linkChecked = true
        this.alreadyLinked = results.data.linked
      }
    );
  },
  methods: {
    checkId() {
      this.$store.dispatch("setExecuting", true)
      api.post("/user/meetupLink", {meetupUserId: this.meetupUserId}).then(
        (results) => {
          this.alreadyLinked = results.data.foundAndLinked
          if (this.alreadyLinked) {
            this.linkedMessage = "Congratulations! You are eligible for an extended free trial. Your account has been updated accordingly."
          } else {
            this.$notify.error({
                                 message: "Sorry, but that is either not an eligible ID, or it has already been claimed.",
                                 timeOut: 20000
                               })
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }

};
</script>
